module.exports = __webpack_public_path__ + "img/logout.6d5597a3.jpg";